import React, { useCallback, useEffect } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import LoginPage from "../pages/login2/components/alert-login/index"
import { useSelector } from 'react-redux'
import Alert from '../components/alters/alert'
import Confirm from '../components/alters/confirm'
import { useDispatch } from 'react-redux'
import { TOOGLE_UI_ALERT, TOOGLE_UI_CONFIRM, TOOGLE_UI_DIRECTION } from '../../store/actions/ui'
import { useScroll } from '../hooks/scroll'
import SizeChartWrapped from './fragments/size-chart2'
import PopupSlideImages from './fragments/popup-slide-images'

export default props => {
    useStyles(classes)

    const ui = useSelector(state => state.ui)
    const dispatch = useDispatch()

    const direction = useScroll()

	useEffect(() => {
		dispatch({
			type: TOOGLE_UI_DIRECTION,
			payload: direction
		})
	}, [direction])

    const closeAlertHandle = useCallback(() => {
        dispatch({
            type: TOOGLE_UI_ALERT,
            payload: null
        })
    }, [])

    const closeConfirmHandle = useCallback(() => {
        dispatch({
            type: TOOGLE_UI_CONFIRM,
            payload: null
        })
    }, [])

    return <div className={classes.CartLayout}>
        {props.children}

        <LoginPage/>
        <Alert show={ui.alert?.show} options={ui.alert?.options} onClose={closeAlertHandle}/>
        <Confirm show={ui.confirm?.show} options={ui.confirm?.options} onClose={closeConfirmHandle}/>
        <SizeChartWrapped/>
        <PopupSlideImages />
    </div>
}